module.exports = __webpack_public_path__ + "img/b_4.a924f8a1.jpg";